"use strict";

function writeHeader() {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "parts_header_common.html", false);
    xhr.send(null);
    if (xhr.status === 200) {
        document.write(xhr.responseText);
    } else if (xhr.status === 404) {
        document.write("404<br>Not Found");
    }
}

function writeNav() {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "parts_nav_common.html", false);
    xhr.send(null);
    if (xhr.status === 200) {
        document.write(xhr.responseText);
    } else if (xhr.status === 404) {
        document.write("404<br>Not Found");
    }
}

function writeFooter() {
    $.ajax({
        url: "parts_footer_common.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeInfo() {
    $.ajax({
        url: "parts_information.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeNavIntroduction() {
    $.ajax({
        url: "parts_nav_introduction.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeNavVoice() {
    $.ajax({
        url: "parts_nav_voice.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeNavEducatipn() {
    $.ajax({
        url: "parts_nav_education.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeNavRecruit() {
    $.ajax({
        url: "parts_nav_recruit.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeNavGuide() {
    $.ajax({
        url: "parts_nav_guide.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}

function writeNavOthers() {
    $.ajax({
        url: "parts_nav_others.html",
        cache: false,
        async: false
    }).done(function (data) {
        document.write(data);
    }).fail(function (data) {
        document.write("error");
    });
}


/***
 *
 * @param {string} dataId タブのIDおよび表示HTMLファイル名
 * @param {string} displayId 表示先のID
 */
function showTabContents(dataId, displayId) {
    let returnValue;

    const list = document.getElementById(dataId).parentNode.childNodes;

    for (let i = 0; i < list.length; i++) {

        let li = list[i];

        if (li.tagName === "LI") {

            if (li.id === dataId) {

                // 選択状態にする
                li.classList.add('tab-current');

                // データを取得して表示する
                // 同期
                const partsFileName = dataId + '.html';
                const xhr = new XMLHttpRequest();
                xhr.open("GET", partsFileName, false);
                xhr.send(null);

                if (xhr.status === 200) {
                    // メインコンテンツの表示
                    document.getElementById(displayId).innerHTML = xhr.responseText;

                    // ページタイトルの表示
                    const page_title = document.getElementById('js_idCtName').innerHTML;
                    const title = document.getElementById(dataId).innerHTML;

                    returnValue = title;

                    document.title = title + " | 習志野第一病院 看護部";

                    // ページ内タイトルの表示
                    const dispClassCtName = document.getElementsByClassName('js_dispClassCtName');
                    for (let ii = 0; ii < dispClassCtName.length; ii++) {
                        dispClassCtName[ii].innerHTML = page_title;
                    }

                    // パンくずリストの表示
                    const bredB = document.getElementById(dataId).innerHTML;

                    document.getElementsByClassName("js_breadcrumbs")[0].getElementsByClassName("js_content-wrap")[0].innerHTML = "<ol><li><a href='index.html'>HOME</a></li>" + "<li>" + page_title + " - " + bredB + "</li></ol>";

                    // URLを書き換える
                    const hUrl = window.location.search.substr(0, window.location.search.lastIndexOf('?')) + '?' + dataId;

                    history.replaceState(null, partsFileName.replace('.html', ''), hUrl);
                } else if (xhr.status === 404) {
                    document.getElementsByClassName(dataId)[0].innerHTML = "404<br>Not found";
                }

            } else {

                // 非選択状態にする
                li.classList.remove('tab-current');
            }
        }
    }

    return returnValue;
}


/***
 *
 * お問い合わせフォーム　希望日時の表示・非表示切り替え
 */
function hyoji() {
    document.getElementById("js-DateVisible").style.display = "block";
}

function hihyoji() {
    document.getElementById("js-DateVisible").style.display = "none";
}